export function asInt<T extends number | null | undefined>(
  str: string,
  fallback: T = undefined as T
): T | number {
  const num = Number(str);
  return isNaN(num) ? fallback : num;
}
